import { render } from "./GameSlotSymbolsEditor.vue?vue&type=template&id=32140817&scoped=true"
import script from "./GameSlotSymbolsEditor.vue?vue&type=script&lang=ts"
export * from "./GameSlotSymbolsEditor.vue?vue&type=script&lang=ts"

import "./GameSlotSymbolsEditor.vue?vue&type=style&index=0&id=32140817&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32140817"

export default script